export default "__VITE_ASSET__c6726444__"